import React, { useState, useEffect } from 'react';
import { Role, TENANT, TENANTS } from '../../config/constant';
import { Tab, Nav } from 'react-bootstrap';


const HierarchyDetails = (props) => {
  const [managersData, setManagersData] = useState({});
  const [secondaryManagersData, setSecondaryManagersData] = useState({});
  const [showSecondaryHierarchy] = useState(false);


  // const handleSecondaryHierarchy = () => {
  //   setShowSecondaryHierarchy(true);
  // }

  useEffect(() => {
  let tempManagersData = { ...managersData };
  let tempSecondaryManagers = { ...secondaryManagersData };
  
  if (props.allManagerList && props.allManagerList.length) {
    for (let data of props.allManagerList) {
      if (TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) {
        if (data.role_id === Role.ARO) {
          tempManagersData['ARO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ARCO) {
          tempManagersData['ARCO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.BM) {
          tempManagersData['BM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.AM) {
          tempManagersData['AM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.DZM) {
          tempManagersData['DZM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ZM) {
          tempManagersData['ZM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RBH) {
          tempManagersData['RBH'] = {
            id: data.id,
            name: data.name,
          };
        }
      }else if(TENANT === TENANTS.FAV) {
        if (data.role_id === Role.FA) {
          tempManagersData['FA'] = {
            id: data.id,
            name: data.name,
          };
        } 
        if (data.role_id === Role.MO) {
          tempManagersData['MO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.MM) {
          tempManagersData['MM'] = {
            id: data.id,
            name: data.name,
          };
        } 
        if (data.role_id === Role.AM) {
          tempManagersData['AM'] = {
            id: data.id,
            name: data.name,
          };
        }              
        if (data.role_id === Role.ARM) {
          tempManagersData['ARM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RM) {
          tempManagersData['RM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RBH) {
          tempManagersData['RBH'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.VP) {
          tempManagersData['VP'] = {
            id: data.id,
            name: data.name,
          };
        }
      }else if(TENANT === TENANTS.PH) {
        if(data.role_id === Role['Sales Manager']){
            tempManagersData['Sales Manager']={
                id: data.id,
                name: data.name,
            }
        }
        if(data.role_id === Role['Territory Head']){
            tempManagersData['Territory Head']={
                id: data.id,
                name: data.name,
            }
        }
        if(data.role_id === Role['Sales Head']){
            tempManagersData['Sales Head']={
                id: data.id,
                name: data.name,
            }
        }
        if(data.role_id === Role.President){
            tempManagersData['President']={
                id: data.id,
                name: data.name,
            }
        }  
        if(data.role_id === Role['ARO']){
          tempManagersData['ARO']={
              id: data.id,
              name: data.name,
          }
        } 
      }else {
        if (data.role_id === Role.KAO) {
          tempManagersData['KAO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ARCO) {
          tempManagersData['ARCO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.BM) {
          tempManagersData['BM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.AM) {
          tempManagersData['AM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RM) {
          tempManagersData['RM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RBH) {
          tempManagersData['RBH'] = {
            id: data.id,
            name: data.name,
          };
        }
      } 
    }
  }

  if (props.secondaryManagersList && props.secondaryManagersList.length) {
    for (let data of props.secondaryManagersList) {
      if (TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) {
        if (data.role_id === Role.ARO) {
          tempSecondaryManagers['ARO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ARCO) {
          tempSecondaryManagers['ARCO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.BM) {
          tempSecondaryManagers['BM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.AM) {
          tempSecondaryManagers['AM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ZM) {
          tempSecondaryManagers['ZM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RBH) {
          tempSecondaryManagers['RBH'] = {
            id: data.id,
            name: data.name,
          };
        }
      } else if(TENANT === TENANTS.FAV) {
        if (data.role_id === Role.MM) {
          tempSecondaryManagers['MM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.FA) {
          tempSecondaryManagers['FA'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.MO) {
          tempSecondaryManagers['MO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ARM) {
          tempSecondaryManagers['ARM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RM) {
          tempSecondaryManagers['RM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RBH) {
          tempSecondaryManagers['RBH'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.VP) {
          tempSecondaryManagers['VP'] = {
            id: data.id,
            name: data.name,
          };
        }
      }else{
        if (data.role_id === Role.KAO) {
          tempSecondaryManagers['KAO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.ARCO) {
          tempSecondaryManagers['ARCO'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.BM) {
          tempSecondaryManagers['BM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.AM) {
          tempSecondaryManagers['AM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RM) {
          tempSecondaryManagers['RM'] = {
            id: data.id,
            name: data.name,
          };
        }
        if (data.role_id === Role.RBH) {
          tempSecondaryManagers['RBH'] = {
            id: data.id,
            name: data.name,
          };
        }
      }
    }
  }

  setSecondaryManagersData(tempSecondaryManagers);
  setManagersData(tempManagersData);
  // eslint-disable-next-line 
}, [props.allManagerList]);



  return (
    <div className="reporting-line-detail">
      <div className="modal-header">
        <h2>Reporting Line</h2>
        <span>
          {"User Details"}
        </span>
      </div>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <div className="dealer-user-mapping-tabs">
          <Nav variant="pills" className="flex-column tab-line">
            <div className="tab-list">
              <Nav.Item>
                <Nav.Link eventKey="first" onClick={() => { }}>Primary Hierarchy</Nav.Link>
              </Nav.Item>
              {/* {props.secondaryManagersList && props.secondaryManagersList.length ? <Nav.Item>
                <Nav.Link eventKey="second" onClick={() => handleSecondaryHierarchy()}> Seconday Hierarchy </Nav.Link>
              </Nav.Item> : ""} */}
            </div>
          </Nav>
        </div>
        <Tab.Content>
          <Tab.Pane eventKey={"first"}>
            {props.allManagerList ? (
              <div className='modal-body'>
                {(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV || TENANT===TENANTS.EMP) ? (
                  <>
                    {(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) && managersData?.ARO?.id && (
                      <>
                        <div className="detail">
                          <div>{"ARO Name"}</div>
                          <div>{managersData?.ARO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ARO ID"}</div>
                          <div>{managersData?.ARO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                     {(TENANT===TENANTS.EMP) && managersData?.KAO?.id && (
                      <>
                        <div className="detail">
                          <div>{"KAO Name"}</div>
                          <div>{managersData?.KAO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"KAO ID"}</div>
                          <div>{managersData?.KAO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.ARCO?.id && (
                      <>
                        <div className="detail">
                          <div>{"ARCO Name"}</div>
                          <div>{managersData?.ARCO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ARCO ID"}</div>
                          <div>{managersData?.ARCO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.BM?.id && (
                      <>
                        <div className="detail">
                          <div>{"BM Name"}</div>
                          <div>{managersData?.BM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"BM ID"}</div>
                          <div>{managersData?.BM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.AM?.id && (
                      <>
                        <div className="detail">
                          <div>{"AM Name"}</div>
                          <div>{managersData?.AM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"AM ID"}</div>
                          <div>{managersData?.AM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {(TENANT===TENANTS.OTO) && managersData?.DZM?.id && (
                      <>
                        <div className="detail">
                          <div>{"DZM Name"}</div>
                          <div>{managersData?.DZM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"DZM ID"}</div>
                          <div>{managersData?.DZM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) && managersData?.ZM?.id && (
                      <>
                        <div className="detail">
                          <div>{"ZM Name"}</div>
                          <div>{managersData?.ZM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ZM ID"}</div>
                          <div>{managersData?.ZM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                      {(TENANT===TENANTS.EMP) && managersData?.RM?.id && (
                      <>
                        <div className="detail">
                          <div>{"RM Name"}</div>
                          <div>{managersData?.RM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RM ID"}</div>
                          <div>{managersData?.RM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.RBH?.id && (
                      <>
                        <div className="detail">
                          <div>{"RBH Name"}</div>
                          <div>{managersData?.RBH?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RBH ID"}</div>
                          <div>{managersData?.RBH?.id || "-"}</div>
                        </div>
                      </>
                    )}
                  </>
                ):(TENANT===TENANTS.PH) ?(
                  <>
                    {managersData['ARO']?.id ? <> <div className="detail">
              <div>{"ARO"}</div>
              <div>{managersData['ARO']?.name || "-"}</div>
            </div>
            <div className="detail">
              <div>{"ARO ID"}</div>
              <div>{managersData['ARO']?.id || "-"}</div>
            </div></> : null}
            {managersData['Sales Manager']?.id ? <> <div className="detail">
              <div>{"Sales Manager Name"}</div>
              <div>{managersData['Sales Manager']?.name || "-"}</div>
            </div>
            <div className="detail">
              <div>{"Sales Manager ID"}</div>
              <div>{managersData['Sales Manager']?.id || "-"}</div>
            </div></> : null}
            {managersData['Territory Head']?.id ? <> <div className="detail">
              <div>{"Territory Head Name"}</div>
              <div>{managersData['Territory Head']?.name || "-"}</div>
            </div>
            <div className="detail">
              <div>{"Territory Head ID"}</div>
              <div>{managersData['Territory Head']?.id || "-"}</div>
            </div></> : null}
            {managersData['Sales Head']?.id ? <> <div className="detail">
              <div>{"Sales Head Name"}</div>
              <div>{managersData['Sales Head']?.name || "-"}</div>
            </div>
            <div className="detail">
              <div>{"Sales Head ID"}</div>
              <div>{managersData['Sales Head']?.id || "-"}</div>
            </div></> : null}
            {managersData['President']?.id ? <> <div className="detail">
              <div>{"President Name"}</div>
              <div>{managersData['President']?.name || "-"}</div>
            </div>
            <div className="detail">
              <div>{"President ID"}</div>
              <div>{managersData['President']?.id || "-"}</div>
            </div></> : null}
                  </>
                ): (
                  <>
                  {managersData?.MO?.id && (
                      <>
                        <div className="detail">
                          <div>{"MO Name"}</div>
                          <div>{managersData?.MO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"MO ID"}</div>
                          <div>{managersData?.MO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.MM?.id && (
                      <>
                        <div className="detail">
                          <div>{"MM Name"}</div>
                          <div>{managersData?.MM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"MM ID"}</div>
                          <div>{managersData?.MM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.FA?.id && (
                      <>
                        <div className="detail">
                          <div>{"FA Name"}</div>
                          <div>{managersData?.FA?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"FA ID"}</div>
                          <div>{managersData?.FA?.id || "-"}</div>
                        </div>
                      </>
                    )} 
                      {managersData?.AM?.id && (
                      <>
                        <div className="detail">
                          <div>{"AM Name"}</div>
                          <div>{managersData?.AM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"AM ID"}</div>
                          <div>{managersData?.AM?.id || "-"}</div>
                        </div>
                      </>
                    )}                   
                    {managersData?.ARM?.id && (
                      <>
                        <div className="detail">
                          <div>{"ARM Name"}</div>
                          <div>{managersData?.ARM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ARM ID"}</div>
                          <div>{managersData?.ARM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.RM?.id && (
                      <>
                        <div className="detail">
                          <div>{"RM Name"}</div>
                          <div>{managersData?.RM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RM ID"}</div>
                          <div>{managersData?.RM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {managersData?.RBH?.id && (
                      <>
                        <div className="detail">
                          <div>{"RBH Name"}</div>
                          <div>{managersData?.RBH?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RBH ID"}</div>
                          <div>{managersData?.RBH?.id || "-"}</div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            ) : (
              ""
            )}
          </Tab.Pane>
          <Tab.Pane eventKey={"second"}>
            {props.secondaryManagersList && showSecondaryHierarchy ? (
              <div className='modal-body'>
                {(TENANT===TENANTS.OTO || TENANT===TENANTS.TRIV) ? (
                  <>
                    {secondaryManagersData?.ARO?.id && (
                      <>
                        <div className="detail">
                          <div>{"ARO Name"}</div>
                          <div>{secondaryManagersData?.ARO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ARO ID"}</div>
                          <div>{secondaryManagersData?.ARO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.ARCO?.id && (
                      <>
                        <div className="detail">
                          <div>{"ARCO Name"}</div>
                          <div>{secondaryManagersData?.ARCO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ARCO ID"}</div>
                          <div>{secondaryManagersData?.ARCO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.BM?.id && (
                      <>
                        <div className="detail">
                          <div>{"BM Name"}</div>
                          <div>{secondaryManagersData?.BM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"BM ID"}</div>
                          <div>{secondaryManagersData?.BM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.AM?.id && (
                      <>
                        <div className="detail">
                          <div>{"AM Name"}</div>
                          <div>{secondaryManagersData?.AM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"AM ID"}</div>
                          <div>{secondaryManagersData?.AM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.ZM?.id && (
                      <>
                        <div className="detail">
                          <div>{"ZM Name"}</div>
                          <div>{secondaryManagersData?.ZM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"ZM ID"}</div>
                          <div>{secondaryManagersData?.ZM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.RBH?.id && (
                      <>
                        <div className="detail">
                          <div>{"RBH Name"}</div>
                          <div>{secondaryManagersData?.RBH?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RBH ID"}</div>
                          <div>{secondaryManagersData?.RBH?.id || "-"}</div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <>
                    {secondaryManagersData?.MM?.id && (
                      <>
                        <div className="detail">
                          <div>{"MM Name"}</div>
                          <div>{secondaryManagersData?.MM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"MM ID"}</div>
                          <div>{secondaryManagersData?.MM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.FA?.id && (
                      <>
                        <div className="detail">
                          <div>{"FA Name"}</div>
                          <div>{secondaryManagersData?.FA?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"FA ID"}</div>
                          <div>{secondaryManagersData?.FA?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.MO?.id && (
                      <>
                        <div className="detail">
                          <div>{"MO Name"}</div>
                          <div>{secondaryManagersData?.MO?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"MO ID"}</div>
                          <div>{secondaryManagersData?.MO?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.RM?.id && (
                      <>
                        <div className="detail">
                          <div>{"RM Name"}</div>
                          <div>{secondaryManagersData?.RM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RM ID"}</div>
                          <div>{secondaryManagersData?.RM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.GM?.id && (
                      <>
                        <div className="detail">
                          <div>{"GM Name"}</div>
                          <div>{secondaryManagersData?.GM?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"GM ID"}</div>
                          <div>{secondaryManagersData?.GM?.id || "-"}</div>
                        </div>
                      </>
                    )}
                    {secondaryManagersData?.RBH?.id && (
                      <>
                        <div className="detail">
                          <div>{"RBH Name"}</div>
                          <div>{secondaryManagersData?.RBH?.name || "-"}</div>
                        </div>
                        <div className="detail">
                          <div>{"RBH ID"}</div>
                          <div>{secondaryManagersData?.RBH?.id || "-"}</div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            ) : (
              ""
            )}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </div>
  );
}

export default HierarchyDetails;